import { Component, Input, OnDestroy, OnInit, ElementRef, ViewChild, Renderer2, Inject } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { Params } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DOCUMENT } from '@angular/common';
import { AuthService } from '../../account/shared/auth.service';
import { CartService } from '../../my-cart/shared/cart.service';
import { CartItem } from '../../models/cart-item.model';
import { Product } from '../../models/product.model';
import { User } from '../../models/user.model';
import { ProductsCacheService } from '../../my-products/shared/products-cache.service';
import { ProductService } from '../../my-products/shared/product.service';
import { ProductRatingService } from '../../my-products/shared/product-rating.service';
import { transformHtmlPrice2 } from '../../utils/transformHtmlPrice';
import { processProductAttribute } from '../../utils/parse-to-any-object';

@Component({
  selector: 'app-my-detail-product',
  templateUrl: './my-detail-product.component.html',
  styleUrls: ['./my-detail-product.component.scss']
})
export class MyDetailProductComponent implements OnInit, OnDestroy {
  @ViewChild('productImage') productImage!: ElementRef;
  @ViewChild('cartIcon') cartIcon!: ElementRef;

  private unsubscribe$ = new Subject<void>();
  @Input() public product: Product;
  productCategory: string;
  public productLoading: boolean = false;
  public user: User;
  detailsPrix: any;
  public imagesLoaded: string[] = [];
  public activeImageUrl: string;
  public activeImageIndex: number = 0;
  public selectedQuantity: number = 1;
  public ratingCount: number;
  public ratingValues: number[];
  public selectedRating: any;
  maxQuantity: number = 10;
  selectedPrice: number;
  selectedPriceIndex: number = 0;
  selectedSection: string = 'description';
  isSectionOpen: { [key: string]: boolean } = {
    olfactive: false,
    availability: false,
    description: false,
    share: false
  };
  isAddingToCart: boolean = false;
  animationItems: number[] = [];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
    private authService: AuthService,
    private cartService: CartService,
    private productsCacheService: ProductsCacheService,
    private productService: ProductService,
    private productRatingService: ProductRatingService,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document
  ) {}

  ngOnInit(): void {
    // Vérifier d'abord si un produit est disponible via getStateProduct
    this.productService.getStateProduct()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((product: Product) => {
        if (product) {
          this.product = product;
          console.log('Product from state:', this.product);
          if (product.detail?.detailsPrix) {
            this.detailsPrix = processProductAttribute(product.detail.detailsPrix).raw;
            console.log('this.detailsPrix', this.detailsPrix);
            this.detailsPrix = {
              ...this.detailsPrix,
              options: this.detailsPrix.options.filter((option: any) =>
                option.data !== null && option.data !== undefined && option.data.special_price != null
              )
            };
            this.selectedPrice = this.parsePrice(
              this.detailsPrix.options[0].data.special_price
            );
          }
          this.productCategory = Object.keys(this.product.familles).find(
            (key) => this.product.familles![key] === true
          ) || null;
          this.activeImageUrl = this.product.detail?.galerie?.data[0]?.img;
          this.setupProduct();
        } else {
          // Si aucun produit n'est trouvé dans le state, utiliser l'URL
          this.route.params
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((params: Params) => {
              this.getProduct();
            });
        }
      });
  }

  parsePrice(priceString: string): number {
    const match = priceString.match(/[\d,.]+/);
    return match ? parseFloat(match[0].replace(',', '.')) : 0;
  }

  private getProduct(): void {
    this.productLoading = true;
    const name = this.route.snapshot.paramMap.get('name');

    this.productService.getProductBySku(name)
     // .getProduct(id)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((product: Product) => {
        if (product) {
          console.log('pr:', product);
          if (product.detail?.detailsPrix) {
            this.detailsPrix = processProductAttribute(product.detail.detailsPrix).raw;
            console.log('this.detailsPrix', this.detailsPrix);
            this.selectedPrice = this.parsePrice(
              this.detailsPrix.options[0].data.special_price || this.detailsPrix.options[0].data.price
            );
          }
          this.product = product;
          this.productCategory = Object.keys(this.product.familles).find(
            (key) => this.product.familles![key] === true
          ) || null;
          this.activeImageUrl = this.product.detail?.galerie?.data[0]?.img;
          this.setupProduct();
          this.productLoading = false;
        } else {
          this.router.navigate(['/404-product-not-found']);
        }
      });
  }

  public onSelectThumbnail(event: Event, index: number): void {
    event.preventDefault();
    this.activeImageUrl = this.product.detail.galerie.data[index].img;
    this.activeImageIndex = index;
  }

  onAddToCart(): void {
    if (!this.product || !this.detailsPrix || this.selectedPriceIndex === undefined) {
      return;
    }

    // Créer l'élément d'animation
    const image = this.productImage.nativeElement.cloneNode(true) as HTMLElement;
    const rect = this.productImage.nativeElement.getBoundingClientRect();

    // Position de départ
    this.renderer.setStyle(image, 'position', 'fixed');
    this.renderer.setStyle(image, 'top', `${rect.top}px`);
    this.renderer.setStyle(image, 'left', `${rect.left}px`);
    this.renderer.setStyle(image, 'width', `${rect.width}px`);
    this.renderer.setStyle(image, 'height', `${rect.height}px`);
    this.renderer.setStyle(image, 'z-index', '1000');
    this.renderer.setStyle(image, 'border-radius', '50%');
    this.renderer.setStyle(image, 'object-fit', 'cover');
    this.renderer.setStyle(image, 'transition', 'all 0.7s cubic-bezier(0.4, 0, 0.2, 1)');
    this.renderer.setStyle(image, 'box-shadow', '0 4px 12px rgba(0, 0, 0, 0.2)');

    this.document.body.appendChild(image);

    // Déclencher l'animation vers une position fixe en haut à droite
    setTimeout(() => {
      this.renderer.setStyle(image, 'top', '20px');
      this.renderer.setStyle(image, 'right', '20px');
      this.renderer.setStyle(image, 'left', 'auto');
      this.renderer.setStyle(image, 'width', '30px');
      this.renderer.setStyle(image, 'height', '30px');
      this.renderer.setStyle(image, 'opacity', '0.5');
      this.renderer.setStyle(image, 'transform', 'scale(0.5)');
    }, 50);

    // Ajouter au panier
    const selectedOption = this.detailsPrix.options[this.selectedPriceIndex];
    const cartItem: CartItem = {
      option: selectedOption,
      product: {...this.product,detail : null},
      quantity: this.selectedQuantity || 1,
      price: this.selectedPrice || this.product.price,
      priceIndex: this.selectedPriceIndex
    };

    this.cartService.addItem(cartItem);

    // Nettoyage après l'animation
    setTimeout(() => {
      image.remove();
    }, 800);
  }

  public onSelectQuantity(): void {
    console.log('Selected quantity:', this.selectedQuantity);
  }

  public onRate(): void {
    const rating = parseInt(this.selectedRating, 10);
    this.productRatingService
      .rateProduct(this.product, rating)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(() => {
        this.getProduct();
      });
  }

  public onImageLoad(e: any): void {
    this.imagesLoaded.push(e.target.src);
  }

  private setupProduct(): void {
    if (this.product) {
      this.checkCategories();
      this.checkRatings();
      this.activeImageUrl = this.product.imageURLs?.[0] || this.product.detail?.galerie?.data[0]?.img;
      this.activeImageIndex = 0;
    }
  }

  private checkCategories(): void {
    const categories = Object.keys(this.product.categories || {}).map(
      (category, index, inputArray) => {
        return index < inputArray.length - 1 ? category + ',' : category;
      }
    );
    this.product.categories =
      categories.length >= 1 && !Array.isArray(this.product.categories)
        ? categories
        : [];
  }

  private checkRatings(): void {
    this.ratingCount = this.product.ratings
      ? Object.keys(this.product.ratings).length
      : 0;

    if (
      this.product.ratings &&
      this.user &&
      Object.keys(this.product.ratings).includes(this.user.uid)
    ) {
      this.selectedRating = this.product.ratings[this.user.uid];
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  changeMainImage(imageUrl: string, index: number): void {
    this.activeImageUrl = imageUrl;
    this.activeImageIndex = index;
  }

  selectPrice(price: string, index: number): void {
    this.selectedPrice = transformHtmlPrice2(price);
    console.log('price transformed:', transformHtmlPrice2(price));
    this.selectedPriceIndex = index;
    console.log('Selected price:', price, 'at index:', index);
  }

  increaseQuantity(): void {
    if (this.selectedQuantity < this.maxQuantity) {
      this.selectedQuantity++;
    }
  }

  decreaseQuantity(): void {
    if (this.selectedQuantity > 1) {
      this.selectedQuantity--;
    }
  }

  onQuantityChange(): void {
    if (this.selectedQuantity < 1) {
      this.selectedQuantity = 1;
    } else if (this.selectedQuantity > this.maxQuantity) {
      this.selectedQuantity = this.maxQuantity;
    }
  }

  toggleSection(section: string): void {
    Object.keys(this.isSectionOpen).forEach((key) => {
      this.isSectionOpen[key] = false;
    });
    this.isSectionOpen[section] = true;
  }

  selectSection(section: string): void {
    this.selectedSection = section;
  }

  protected readonly window = window;
}
